import React from "react";
import DataGridPolice from "./datagrid/DataGridPolice";

const Police = () => {
  return (
    <>
      <DataGridPolice />
    </>
  );
};

export default Police;
